import { render, staticRenderFns } from "./ListaLogs.vue?vue&type=template&id=66b55bd9"
import script from "./ListaLogs.vue?vue&type=script&lang=js"
export * from "./ListaLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports